import { render, staticRenderFns } from "./CandidateSlotGrid.vue?vue&type=template&id=4c6583e0&scoped=true&"
import script from "./CandidateSlotGrid.vue?vue&type=script&lang=js&"
export * from "./CandidateSlotGrid.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSlotGrid.vue?vue&type=style&index=0&id=4c6583e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6583e0",
  null
  
)

export default component.exports